module.exports = __webpack_public_path__ + "static/img/wd.0d8017b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wd.png
// module id = m6eu
// module chunks = 1